/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod/v4";

/**
 * @description Channel through which the interaction took place (e.g. email ingestion, call log, manual note).
 */
export const interactionChannelSchema = z.enum(["email", "call", "meeting", "sms", "memo", "api", "enrichment"]).describe("Channel through which the interaction took place (e.g. email ingestion, call log, manual note).")